export interface AudioRightsManifestEntry {
  readonly id: string;
  readonly kind: 'procedural';
  readonly author: 'Buncha Games';
  readonly generator: string;
  readonly license: 'Project-authored procedural audio';
  readonly exportSafe: true;
  readonly notes: string;
}

export interface AudioRightsManifest {
  readonly version: 1;
  readonly entries: readonly AudioRightsManifestEntry[];
}

export const RIDE_AUDIO_RIGHTS_MANIFEST: AudioRightsManifest = Object.freeze({
  version: 1,
  entries: Object.freeze([
    Object.freeze({
      id: 'procedural.wind',
      kind: 'procedural',
      author: 'Buncha Games',
      generator: 'seeded-noise-loop',
      license: 'Project-authored procedural audio',
      exportSafe: true,
      notes: 'Deterministic seeded noise generated in the browser; no source recording.',
    }),
    Object.freeze({
      id: 'procedural.wheel-rhythm',
      kind: 'procedural',
      author: 'Buncha Games',
      generator: 'web-audio-oscillator',
      license: 'Project-authored procedural audio',
      exportSafe: true,
      notes: 'Oscillator and filter layer generated in the browser; no source recording.',
    }),
    Object.freeze({
      id: 'procedural.semantic-cues',
      kind: 'procedural',
      author: 'Buncha Games',
      generator: 'seeded-buffer-synth',
      license: 'Project-authored procedural audio',
      exportSafe: true,
      notes: 'Event cues are synthesized from waves and seeded noise; no source recording.',
    }),
  ]),
});
